import Swiper from 'swiper/bundle';

$(document).ready(() => {
    $('.individual-product__wrapper').each(function () {
        const $container = $(this);

        new Swiper($container.find('.individual-product__slider')[0], {
            loop: true,
            navigation: {
                nextEl: $container.find('.swiper-button-next')[0],
                prevEl: $container.find('.swiper-button-prev')[0],
            },
            pagination: {
                el: $container.find('.swiper-pagination')[0],
                clickable: true,
            },
        });
    });
});